export const getPackagingPayload = ({
  name,
  type,
  length,
  width,
  height,
  dimensionUnit,
  weight,
  weightUnit,
  isDefault,
}) => {
  return {
    name,
    type,
    length: Number(length),
    width: Number(width),
    height: Number(height),
    dimension_unit: dimensionUnit,
    weight: Number(weight),
    weight_unit: weightUnit,
    is_default: isDefault,
  }
}
